const dict_management_en = {
  edit_dict_type_info:'edit dictionary type information',
  edit_dict_info:'edit dictionary information',
  dict_warning:'The system dictionary is associated with the enumeration in the code and cannot be modified after adding',
  empty_type_name:'Please enter a type name',
  empty_type_code:'Please enter a type code',
  empty_dict_name:'Please enter a dictionary name',
  empty_cict_code:'Please enter a dictionary code',
  empty_super_dict:'Please select a superior dictionary'
}

export default dict_management_en



// WEBPACK FOOTER //
// ./src/common/lang/dict_management/dict_management_en.js